import { render, staticRenderFns } from "./PMProjectCard.vue?vue&type=template&id=879f7ca8&"
import script from "./PMProjectCard.vue?vue&type=script&lang=ts&"
export * from "./PMProjectCard.vue?vue&type=script&lang=ts&"
import style0 from "./PMProjectCard.vue?vue&type=style&index=0&id=879f7ca8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports